module.exports = function init_parallax() {
  
  const px_containers = document.querySelectorAll('.parallax-effect .fl-photo-content');
  const scale_factor = 1.3;
  const container_pct = 0.3;
  
  px_containers.forEach((container) => {

    const img = container.querySelector('img');
    
    function reset_img(callback) {
      
      img.style.maxwidth = '100%';
      img.style.transform = 'none';
      img.style.position = 'relative';
      img.style.left = 'unset';
      img.style.top = 'unset';
      container.style.height = 'auto';
      container.style.width = 'auto';

      if (callback) callback();
    }

    function build_parallax(callback) {
      
      // get the container's height and width and make these static 
      // so the absolute position of its image isn't a problem
      const container_rect = container.getBoundingClientRect();
      const container_width = container_rect.width;
      const container_ht = container_rect.height;
      container.style.height = `${container_ht}px`;
      container.style.width = `${container_width}px`;

      // then set the image properties
      img.style.maxwidth = 'none';
      img.style.transform = `translate(-50%, -50%) scale(${scale_factor})`;
      img.style.position = 'absolute';
      img.style.left = '50%';
      img.style.top = '50%';

      if (callback) callback();
    }

    // finally, add parallax effect on scroll
    function update_parallax() {
      const container_rect = container.getBoundingClientRect();
      const container_ht = container_rect.height;
      const container_top = container_rect.top;
      const viewport_height = window.innerHeight;

      if (container_top < viewport_height && container_top > -container_ht) {
        const scroll_percentage = (viewport_height - container_top) / (viewport_height + container_ht);
        const move_range = container_ht * container_pct;
        const parallax_offset = (scroll_percentage - 0.5) * move_range;
        img.style.transform = `translate(-50%, calc(-50% + ${parallax_offset}px)) scale(${scale_factor})`;
      }
    }

    window.addEventListener('scroll', () => requestAnimationFrame(update_parallax));
    window.addEventListener('resize', () => {
      reset_img(() => {
        build_parallax(() => {
          requestAnimationFrame(update_parallax);
        });
      });
    });

    // initial update
    build_parallax(() => {
      requestAnimationFrame(update_parallax);
    });
  });

}

